import { postSS } from '@Src/apiServices/baseService';
import { notification } from 'antd';
import moment from 'moment';

export const getInvoiceDetails = async (requestToken: string, refId: string) =>
  new Promise((resolve, reject) => {
    const data = {
      token: requestToken,
      refId,
      refType: 'EXTERNAL_INVOICE',
      tokenType: 'grn_acknowledgement',
    };
    postSS({ url: 'grn-ack/authenticate', data })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const acceptGrn = async (data: any) =>
  new Promise((resolve, reject) => {
    postSS({ url: 'external-grn', data })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        notification.error({
          message: 'ERROR',
          description: err.message || 'Failed to accept GRN',
        });
        reject(err);
      });
  });

export const formatData = (
  requestToken: string | null,
  invoiceData: any,
  grnDetails: any
) => {
  const data = {
    token: requestToken,
    refType: 'EXTERNAL_INVOICE',
    refId: invoiceData.id,
    receivedAt: moment(grnDetails.receivedAt).format(),
    lineItems: [],
    comments: grnDetails.comments,
    documents: grnDetails.document
      ? [
          {
            documentType: 'OTHER',
            documentNumber: null,
            file: grnDetails.document,
          },
        ]
      : null,
  };
  data.lineItems = invoiceData.documentDetails.addItems.items.map(
    (item: any) => ({
      key: item.key,
      itemName: item.itemName,
      hsn: item.hsn,
      unit: item.unit,
      quantity: item.quantity,
      receivedQuantity: item.quantity,
    })
  );
  return data;
};

export const getBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
